<template>
  <div :class="`editor-wrapper`"
       :style="{width:`${width} !important`,borderTop:border?'2px solid #ebebeb':'none',borderRight:border?'2px solid #ebebeb':'none'}"
       ref="editorBox">
    <!--    <div v-if="loading" class="loading-animation sp_box">-->
    <!--      &lt;!&ndash; 你的加载动画，可以是一个简单的 GIF，SVG 或 CSS 动画 &ndash;&gt;-->
    <!--      <div v-loading="loading"></div>-->
    <!--    </div>-->
    <Editor
        :id="tinymceId"
        v-model="content"
        :api-key="tiny.apiKey"
        :tinymceScriptSrc="`/tinymce/tinymce.min.js`"
        :init="tiny.init"
        ref="tinyMCEEditor"
    />
  </div>
</template>

<script setup>
import {defineExpose, ref, reactive, onBeforeUnmount, defineProps, watch, nextTick, onMounted, computed} from 'vue';
import Editor from "@tinymce/tinymce-vue";
import * as SETTING from "/public/static/setting.json"
import {string} from "mockjs/src/mock/random/basic";
import {uploadFile} from "@/utils/file";
import {debouncePlus} from "@/utils/mylodash";
import {registerCustomFontPlugin} from "../../../public/tinymce/plugins/customfontfamily";
import {mailFrontUserEdit} from "@/api/usercenter";
import {ElMessage} from "element-plus";
import {useStore} from "vuex";
import {Storage} from "@/utils/storage"

const userInfo = computed(() => store.state.user.userInfo)

const props = defineProps({
  editorId: {
    type: String,
    required: true,
  },
  initialContent: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: "100%"
  },
  height: {
    type: string,
    default: "100%"
  },
  border: {
    type: Boolean,
    default: true,
  }
});

const default_font_family = ref(`"Microsoft YaHei", sans-serif`)
const default_font_size = ref("14px")
const defaultFontStorageKey = 'tinymce-default-font-family';
let defaultFont = Storage.get(defaultFontStorageKey) || default_font_family.value;
const emit = defineEmits(['iframeScroll'])
const store = useStore()
// const loading = ref(true)
const content = ref("");
const tinymceId = ref(`vue-tinymce-${props.editorId}-${+new Date()}`);  // Unique ID for each instance
const editorBox = ref(null)
const tiny = reactive({
  apiKey: SETTING.TINYMEC_API_KEY, // Replace with your API key
  init: {
    content_style:
        `@import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');
        body {
           font-family: ${defaultFont};
           font-size: ${default_font_size.value};
        }
        .tiny_edit_br_simulation_p {
            line-height: normal !important;
        }
        .tiny_edit_br_simulation_p_original_message{
            line-height: 1.4 !important;、
        }
        
        `,
    selector: `#${tinymceId.value}`,
    inline: false,        // 禁用内联模式
    // 回车换行 变为 br
    // invert交换 Enter 和 Shift+Enter 行为。
    // newline_behavior: "invert",
    language: localStorage.getItem('lang') === 'en' ? 'en' : "zh_CN",
    placeholder: localStorage.getItem('lang') === 'en' ? 'Enter text here' : "在这里输入文字",
    ui_mode: 'split',
    toolbar_sticky: true,
    toolbar_mode: 'sliding',
    quickbars_selection_toolbar: false,
    max_height: 100, // 可选：设置最大高度限制
    autoresize_bottom_margin: 10, // 内容底部的额外空间
    resize: "both",
    contextmenu: false,
    branding: false,
    draggable_modal: true,
    fullscreen_native: true,
    menubar: false,
    paste_remove_styles: false,
    paste_remove_styles_if_webkit: false,
    // toolbar_drawer: false,
    // convert_urls: false,
    // reloading: false,
    paste_as_text: false,
    paste_enable_default_filters: false,
    valid_elements: '*[*]', // 允许所有元素和所有属性
    extended_valid_elements: 'span[style|class]', // 允许span的style和class
    invalid_elements: 'iframe,script,img,table,div',
    cleanup: true,
    verify_html: true,
    external_plugins: {
      "formatpainter": "/tinymce/plugins/formatpainter/index.js",
      "customfontfamily": "/tinymce/plugins/customfontfamily/index.js",
      // "ai": "/tinymce/plugins/ai/index.js",
    },
    // fontfamily
    plugins: 'preview paste searchreplace autolink directionality visualblocks visualchars fullscreen image link media code codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help emoticons formatpainter autoresize',
    toolbar: 'undo redo | cut paste copy pastetext | customfontfamily fontsizeinput | forecolor backcolor | bold italic underline strikethrough | link anchor removeformat formatpainter | lineheight alignleft aligncenter alignright alignjustify | code | image table | outdent indent| styleselect formatselect |bullist numlist |blockquote subscript superscript |charmap emoticons |hr pagebreak| insertdatetime print |preview fullscreen',
    font_size_formats: '8px 10px 12px 14px 16px 18px 20px 24px 36px 4l0px 48px',
    line_height_formats: '0.5 1.0 1.5 2.0 2.5 3.0',
    default_font_stack: ['-apple-system', 'Arial'],
    font_family_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=SimSun, 宋体, serif;仿宋体=FangSong, 仿宋, serif;黑体=SimHei,sans-serif;楷体=kaiti,楷体,STKaiti;helvetica;sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino,Verdana=verdana, geneva;Times New Roman=times new roman, serif;Calibri=calibri, sans-serif; Century Gothic=century gothic, sans-serif;Comic Sans MS=comic sans ms, sans-serif;Arial=arial;Tahoma;Verdana=verdana, geneva, sans-serif;Courier New=courier new, courier, monospace;',
    // font_family_formats: getFontFamilyFormats(),
    file_picker_types: "image",
    paste_data_images: true, // 禁用 base64
    file_picker_callback: (cb, value, meta) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.addEventListener('change', (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.addEventListener('load', async () => {
          /*
            Note: Now we need to register the blob in TinyMCEs image blob
            registry. In the next release this part hopefully won't be
            necessary, as we are looking to handle it internally.
          */
          const result = await uploadFile(file);
          if (result.url) {
            /* call the callback and populate the Title field with the file name */
            cb(result.url, {title: file.name});
          }
        });
        reader.readAsDataURL(file);
      });
      input.click();
    },
    setup: function (editor) {
      let overflowToggleTs = 0;
      const getOverflowToggleBtn = () => {
        const container = editor.getContainer();
        if (!container) return null;
        return (
          container.querySelector('.tox-tbtn[aria-label*="显示或隐藏其他工具栏项"]') ||
          container.querySelector('.tox-tbtn[aria-label*="Show or hide additional toolbar items"]')
        );
      };
      const isRecentOverflowToggle = () => Date.now() - overflowToggleTs < 800;

      // 初始化完成逻辑
      editor.on('init', async function () {
        // loading.value = false;

        if (props.initialContent?.trim()) {
          await editor.setContent(props.initialContent);
          // changeFirstLine(editor)
          // 将光标定位在内容的最开始
          // await changeBlankLine(editor, defaultFont)
          await editor.selection?.setCursorLocation(editor.getBody().firstChild, 0);
          await editor.focus(); // 让编辑器获取焦点
        }

        const container = editor.getContainer();
        if (container && !container.__overflowFocusGuardInstalled) {
          container.__overflowFocusGuardInstalled = true;

          container.addEventListener(
            'mousedown',
            (e) => {
              const btn = getOverflowToggleBtn();
              if (!btn) return;
              if (e.target && btn.contains(e.target)) {
                overflowToggleTs = Date.now();
              }
            },
            true
          );

          container.addEventListener(
            'keydown',
            (e) => {
              if (!e || (e.key !== 'Enter' && e.key !== ' ')) return;
              const btn = getOverflowToggleBtn();
              if (!btn) return;
              if (e.target && btn.contains(e.target)) {
                overflowToggleTs = Date.now();
              }
            },
            true
          );

          container.addEventListener(
            'focusin',
            (e) => {
              if (!isRecentOverflowToggle()) return;
              const btn = getOverflowToggleBtn();
              if (!btn) return;
              const target = e.target;
              if (target && target !== btn && typeof target.blur === 'function') {
                target.blur();
                btn.focus();
              }
            },
            true
          );
        }
      });

      // 注册自定义字体插件
      registerCustomFontPlugin({
        onSetDefaultFont: async (font, editor) => {
          try {
            const res = await mailFrontUserEdit({id: userInfo.value.id, userFront: font});
            if (res.code !== 200) {
              ElMessage.error(res.message);
              return;
            }

            ElMessage.success(res.message);
            await store.dispatch('user/getUserInfoForGUID');
            // 更新字体状态按钮
            // editor.formatter.apply('fontname', { value: font });
            // editor.ui.registry.getAll().buttons.customfontfamily?.update?.();
          } catch (e) {
            ElMessage.error(e.message || '设置默认字体失败');
          }
        }
      });

      // 拦截 error 通知
      editor.on('NotificationManager:beforeShow', function (e) {
        if (e.notification.type === 'error') {
          e.preventDefault();
        }
      });

      // 工具栏焦点行为禁用
      editor.on('ToolbarToggle', function () {
        const container = editor.getContainer();
        const toolbar = container?.querySelector('.tox-toolbar');
        if (toolbar) toolbar.setAttribute('tabindex', '-1');

        window.setTimeout(() => {
          if (!isRecentOverflowToggle()) return;
          const btn = getOverflowToggleBtn();
          if (!btn) return;
          const active = document.activeElement;
          if (active && active !== btn && container && container.contains(active) && typeof active.blur === 'function') {
            active.blur();
          }
          if (typeof btn.focus === 'function') {
            btn.focus();
          }
        }, 0);
      });

      // copy 方法重写
      editor.on('copy', function (event) {
        event.preventDefault();

        // 1) 取选中 HTML
        let html = editor.selection.getContent({format: 'html'}) || '';

        // 2) 把“视觉上空行”的 <p> 统一替换为 <br>
        //    (只包含空白/nbsp/<br> 的 p 都视为“空”)
        html = html.replace(
            /<p[^>]*>\s*(?:&nbsp;|\u00A0|\s|<br\s*\/?>)*\s*<\/p>/gi,
            '<br>'
        );

        // 3) 从规范化后的 HTML 生成“严格可控”的 text/plain
        const EOL = '\n'; // 如需兼容 Windows，可用: /\bWin/.test(navigator.platform) ? '\r\n' : '\n';

        // 3.1 用换行符标出结构性断行，再去标签
        let textish = html
            .replace(/<br\s*\/?>/gi, EOL)                     // <br> -> 换行
            .replace(/<\/p\s*>/gi, EOL)                       // 段落结束 -> 换行
            .replace(/<p[^>]*>/gi, '')                        // 去掉 <p> 起始
            .replace(/<\/(div|h[1-6]|li|blockquote|pre|section|article|tr)>/gi, EOL)
            .replace(/<(div|h[1-6]|li|blockquote|pre|section|article|tr)[^>]*>/gi, '')
            .replace(/<\/?(ul|ol|table|thead|tbody|tfoot)>/gi, ''); // 容器标签直接忽略

        // 3.2 用 DOM 解实体，得到纯文本
        const tmp = document.createElement('div');
        tmp.innerHTML = textish;
        let text = (tmp.textContent || '').toString();

        // 3.3 规范空白与换行（防止出现“异常宽”的空白）
        text = text
            .replace(/\u00A0/g, ' ')     // nbsp -> 普通空格
            .replace(/\r\n?/g, '\n')     // 统一为 LF
            .replace(/[ \t]+\n/g, '\n')  // 行尾多余空格
            .replace(/\n{3,}/g, '\n\n')  // 折叠 3+ 个空行为最多 2 个
            .replace(/^\n+|\n+$/g, '');  // 去除首尾空行

        // 4) 写入剪贴板（textarea 只会用 text/plain，但同时保留 html 以便粘到富文本处）
        event.clipboardData.setData('text/plain', text);
        event.clipboardData.setData('text/html', html);
      });

      // 粘贴图片上传处理
      editor.on('paste', async function (event) {
        const clipboardData = event.clipboardData || window.clipboardData;
        if (!clipboardData) return;

        const items = clipboardData.items;
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.type.indexOf('image') !== -1) {
            event.preventDefault();
            const file = item.getAsFile();

            const uploadId = 'upload-' + Date.now() + '-' + i;
            editor.insertContent(`<span class="uploading-image" style="color: #0a84ff;font-size: 14px;" data-upload-id="${uploadId}">图片上传中...</span>`);

            try {
              const result = await uploadFile(file);
              if (result.url) {
                const span = editor.getDoc().querySelector(`span.uploading-image[data-upload-id="${uploadId}"]`);
                if (span) {
                  const img = editor.getDoc().createElement('img');
                  img.src = result.url;
                  span.parentNode.replaceChild(img, span);
                }
              } else {
                updatePlaceholder(uploadId, '❌ 上传失败');
              }
            } catch (err) {
              console.error('上传错误:', err);
              updatePlaceholder(uploadId, '❌ 上传失败');
            }
          }
        }

        function updatePlaceholder(id, message) {
          const span = editor.getDoc().querySelector(`span.uploading-image[data-upload-id="${id}"]`);
          if (span) span.innerText = message;
        }
      });
    },
    init_instance_callback: async function (editor) {
      console.log(editor, '编辑器加载完毕', editor.initialized, props.initialContent)
      // 确保编辑器完全初始化后再设置内容
      if (editor.initialized) {
        await editor.setContent(props.initialContent);
        // changeFirstLine(editor)
        // 将光标定位在内容的最开始
        // await changeBlankLine(editor, defaultFont)
        try {
          await editor.selection.setCursorLocation(editor.getBody().firstChild, 0);
          await editor.focus(); // 让编辑器获取焦点
        } catch (e) {
          console.log(e)
        }

        // 页面加载完毕后
        await nextTick(() => {
          const iframe = document.querySelector('iframe.tox-edit-area__iframe')
          console.log(iframe, 'iframe')
          if (iframe && iframe.contentWindow) {
            const iframeDoc = iframe.contentWindow.document

            // 监听 iframe 内部的输入事件
            // iframeDoc.addEventListener('keydown', (e) => {
            //   console.log('iframe keydown:', e.key)
            // })

            // 或监听滚动事件
            iframeDoc.addEventListener('scroll', debouncePlus(() => {
              const doc = iframeDoc.documentElement || iframeDoc.body;
              const {scrollTop, scrollHeight, clientHeight} = doc;

              const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
              console.log(distanceFromBottom, 'distanceFromBottom');
              if (distanceFromBottom < 1000) {
                console.log('distanceFromBottom---ok');
                scroll();
              }
            }, 500), {passive: true});  // ✅ 显式为 passive，避免浏览器警告

            // 如果需要监听 <body> 滚动：
            iframeDoc.body?.addEventListener('scroll', () => {
              console.log('iframe body scroll')
            })
          }
        })
      }
    },
  },
});

const tinyMCEEditor = ref(null);

// 设置第一行的字体样式
// const changeFirstLine = (editor) => {
//   const blocks = editor.getBody().querySelectorAll('p, div, span');
//
//   if (blocks.length > 0) {
//     const firstNode = blocks[0];
//
//     // 递归查找最深子元素（没有子元素的）
//     function getDeepestElement(node) {
//       if (!node.children || node.children.length === 0) {
//         return node;
//       }
//       // 这里取第一个子元素继续递归，你也可以根据需求改成找所有子元素中最深的
//       return getDeepestElement(node.children[0]);
//     }
//
//     const deepestElement = getDeepestElement(firstNode);
//
//     // 读取最内层元素的 font-family
//     const innerFont = editor.dom.getStyle(deepestElement, 'font-family', true);
//     console.log(innerFont, 'innerFont')
//     if (innerFont) {
//       // 设置第一个元素的字体为最内层元素的字体
//       editor.dom.setStyle(firstNode, 'font-family', innerFont);
//     }
//   }
// }

function getFirstTextNodeWithFontFamily(editor) {
  function findTextNode(node) {
    if (!node) return null;
    if (node.nodeType === 3 && node.nodeValue.trim() !== '') {
      return node;
    }
    if (node.nodeType === 1 && node.hasChildNodes()) {
      for (let i = 0; i < node.childNodes.length; i++) {
        const found = findTextNode(node.childNodes[i]);
        if (found) return found;
      }
    }
    return null;
  }

  const body = editor.getBody();
  const firstTextNode = findTextNode(body);
  return firstTextNode;
}

watch(() => props.initialContent, (newValue, oldValue) => {
  const editor = tinyMCEEditor.value?.getEditor();
  // console.log('initialContent', newValue, oldValue)
  if (editor && newValue) {
    editor.setContent(props.initialContent);
    // 将光标定位在内容的最开始
    try {
      editor.selection.setCursorLocation(editor.getBody().firstChild, 0);
      editor.focus(); // 让编辑器获取焦点
    } catch (e) {
      console.log(e)
    }
  }
}, {deep: true});

onBeforeUnmount(() => {
  const editor = tinyMCEEditor.value?.getEditor();
  if (editor) {
    editor.remove()
  }
})

onMounted(() => {
  nextTick(() => {
    if (props.height) {
      tiny.init.max_height = props.height
    }
  })
  console.log(tiny, 'tiny')
})
const scroll = () => {
  emit('iframeScroll')
}
defineExpose({
  tinyMCEEditor,
  editorBox,
  scroll,
})
</script>

<style lang="less" scoped>
.editor-wrapper {
  //overflow: scroll;
  height: 100%;
}

.sp_box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  overflow: hidden;
}


/* 滚动条的宽度设置 */
.editor-wrapper::-webkit-scrollbar {
  width: 4px; /* 这里设置滚动条的宽度 */
}

/* 滚动条轨道 */
.editor-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* 滚动条滑块 */
.editor-wrapper::-webkit-scrollbar-thumb {
  background: #dedddd;
  border-radius: 4px;
}

/* 滑块在悬停时的颜色 */
.editor-wrapper::-webkit-scrollbar-thumb:hover {
  background: #dedddd;
}

:deep(.tox-statusbar) {
  display: none !important;
}

:deep(.tox-toolbar__group) {
  padding: 0 0px 0 5px !important;
}

:deep(.tox-editor-dock-fadeout) {
  opacity: 1 !important;
  visibility: visible !important;
}

:deep(.tox:not(.tox-tinymce-inline) .tox-editor-header) {
  padding: 0px !important;
}

:deep(.tox-tinymce) {
  border-radius: unset !important;
  border: none !important;
  height: 100% !important;
}

:deep(.tox .tox-edit-area__iframe) {
  height: 100% !important;
  overflow: scroll !important;
}


:deep(.editor-wrapper) {
  textarea {
    height: 100% !important;

    :deep(.tox-editor-container) {
      height: 100% !important;
    }
  }
}

:deep(.tox-tbtn[data-mce-name="customfontfamily"]) {
  width: 140px !important;
  display: flex !important;
  justify-content: space-between !important;
  background: #f6f6f6 !important;
}


//自定义组件的样式
:deep(.tox-collection__item[aria-label^="微软雅黑"]) {
  font-family: "Microsoft YaHei", "Helvetica Neue", "PingFang SC", sans-serif !important;
}

:deep(.tox-collection__item[aria-label^="宋体"]) {
  font-family: SimSun, 宋体, serif !important;
}

:deep(.tox-collection__item[aria-label^="仿宋体"]) {
  font-family: FangSong, 仿宋, serif !important;
}

:deep(.tox-collection__item[aria-label^="黑体"]) {
  font-family: SimHei, sans-serif !important;
}

:deep(.tox-collection__item[aria-label^="楷体"]) {
  font-family: KaiTi, 楷体, STKaiti !important;
}

:deep(.tox-collection__item[aria-label^="Helvetica"]) {
  font-family: helvetica, sans-serif !important;
}

:deep(.tox-collection__item[aria-label^="Arial Black"]) {
  font-family: "arial black", "avant garde" !important;
}

:deep(.tox-collection__item[aria-label^="Book Antiqua"]) {
  font-family: "book antiqua", palatino !important;
}

:deep(.tox-collection__item[aria-label^="Verdana"]) {
  font-family: verdana, geneva !important;
}

:deep(.tox-collection__item[aria-label^="Times New Roman"]) {
  font-family: "times new roman", serif !important;
}

:deep(.tox-collection__item[aria-label^="Calibri"]) {
  font-family: calibri, sans-serif !important;
}

:deep(.tox-collection__item[aria-label^="Century Gothic"]) {
  font-family: "century gothic", sans-serif !important;
}

:deep(.tox-collection__item[aria-label^="Comic Sans MS"]) {
  font-family: "comic sans ms", sans-serif !important;
}

:deep(.tox-collection__item[aria-label="Arial"]) {
  font-family: arial !important;
}

:deep(.tox-collection__item[aria-label="Arial ✔"]) {
  font-family: arial !important;
}

:deep(.tox-collection__item[aria-label^="Tahoma"]) {
  font-family: tahoma !important;
}

:deep(.tox-collection__item[aria-label^="Courier New"]) {
  font-family: "courier new", courier, monospace !important;
}

:deep(.tiny_edit_br_simulation_p ) {
  line-height: normal !important;
}

.tiny_edit_br_simulation_p {
  line-height: normal !important;
}
</style>